import { Pipe, PipeTransform } from '@angular/core';
import {Equipement} from '../../models/equipement.model';

@Pipe({ name: 'equipement' })
export class EquipementPipe implements PipeTransform {
    transform(values: Equipement[], filter: string): Equipement[] {
        if (!filter || filter.length === 0) {
            return values;
        }

        if (values.length === 0) {
            return values;
        }

        return values.filter((value: Equipement) => {
            if (value.no_equipement.toLowerCase().indexOf(filter.toLowerCase()) !== -1) {
                return value;
            }
        });
    }
}
